export const menuLinks = [
    {title: 'Home', link : '/'},
    {title: 'Sakleshpur', link : '/sakleshpur'},
    {title: 'Chikmagalur', link : '/chikmagalur'},
    {title: 'Coorg', link : '/coorg'},
    {title: 'Package', link : '/packages'},
    {title: 'Trip Ideas', link : '/tripideas'},
    {title: 'About', link : '/about'},
    // {title: 'Contact US', link : '/'}
]